import gql from 'graphql-tag'
import {
  PRODUCT_AVAILABILITY_FRAGMENT,
  PRODUCT_ESTIMATED_DELIVERY_FRAGMENT,
} from '~/graphql/gql/product/fragments'
import { PRODUCT_BY_VARIANT_IDS } from '~/graphql/gql/product/fragments/productVariantsIdsFragment'

export const GET_PRODUCTS_FOR_DETAIL_RECOMMENDED = gql`
  query getProductsByVariantIdsForDetailRecommended(
    $ids: [ID!]!
    $ignoreMissing: Boolean = false
  ) {
    products: getProductsByVariantIds(
      ids: $ids
      query: { ignoreMissing: $ignoreMissing }
    ) {
      ...ProductVariantsIdsFragment
    }
  }

  ${PRODUCT_BY_VARIANT_IDS}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`

export const GET_PRODUCTS_FOR_BANNER = gql`
  query getProductsByVariantIdsForBanner(
    $ids: [ID!]!
    $ignoreMissing: Boolean = false
  ) {
    products: getProductsByVariantIds(
      ids: $ids
      query: { ignoreMissing: $ignoreMissing }
    ) {
      ...ProductVariantsIdsFragment
    }
  }

  ${PRODUCT_BY_VARIANT_IDS}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`

export const GET_PRODUCTS_FOR_CATEGORY_MULTI_PRICING = gql`
  query getProductsByVariantIdsForCategoryMultiPricing(
    $ids: [ID!]!
    $ignoreMissing: Boolean = false
  ) {
    products: getProductsByVariantIds(
      ids: $ids
      query: { ignoreMissing: $ignoreMissing }
    ) {
      ...ProductVariantsIdsFragment
    }
  }

  ${PRODUCT_BY_VARIANT_IDS}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`

export const GET_PRODUCTS_FOR_DETAIL_MULTI_PRICING = gql`
  query getProductsByVariantIdsForDetailMultiPricing(
    $ids: [ID!]!
    $ignoreMissing: Boolean = false
  ) {
    products: getProductsByVariantIds(
      ids: $ids
      query: { ignoreMissing: $ignoreMissing }
    ) {
      ...ProductVariantsIdsFragment
    }
  }

  ${PRODUCT_BY_VARIANT_IDS}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`
